/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Hidden } from "@material-ui/core";
import { cloneDeep } from "lodash";

import uiConf from "../../../config/uiConf";
import getSchema from "../../../lib/api/getSchema";
import { getOption } from "../../../lib/api/getOptions";

import notificationState from "../../../states/notificationState";
import BasicCrudScreenTypeLayout from "../layout/BasicCrudScreenTypeLayout";
import BasicCrudScreenHeaderLayout from "../layout/BasicCrudScreenHeaderLayout";
import BasicCrudScreenContentLayout from "../layout/BasicCrudScreenContentLayout";
import BasicCrudScreenContentWithoutFooterLayout from "../layout/BasicCrudScreenContentWithoutFooterLayout";
import BasicCrudScreenFooterLayout from "../layout/BasicCrudScreenFooterLayout";
import BasicCrudActionsLayout from "../layout/BasicCrudActionsLayout";
import BasicCrudScreenActionItemLayout from "../layout/BasicCrudScreenActionItemLayout";

import ToolbarFlexSpacer from "../../layout/ToolbarFlexSpacer";

import Filter from "../../functional/Filter";
import Search from "../../functional/Search";
import OrderBy from "../../functional/OrderBy";
import Pagination from "../../functional/Pagination";
import GetListApi from "../../functional/GetListApi";

import CreateRecordButton from "../../input/CreateRecordButton";
import UpdateRecordButton from "../../input/UpdateRecordButton";
import DeleteRecordButton from "../../input/DeleteRecordButton";
import SaveToExcelButton from "../../input/SaveToExcelButton";

import SearchTextField from "../../input/SearchTextField";
import OpenFilterButton from "../../input/OpenFilterButton";

import FilterConditionPanelLayout from "../../layout/FilterConditionPanelLayout";

import AutoFilterForm from "../../filter/functional/AutoFilterForm";
import FilterApplyButton from "../../input/FilterApplyButton";
import FilterClearButton from "../../input/FilterClearButton";
import FilterCancelButton from "../../input/FilterCancelButton";

import AutoDataGrid from "../../grid/functional/AutoDataGrid";

import PaginationControl from "../../input/PaginationControl";
import OutputSizeSelect from "../../input/OutputSizeSelect";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import ApprovalButton from "../../input/ApprovalButton";

import AccessControl from "../../functional/AccessControl";

import FilterDialog from "../../dialogTypes/FilterDialog";


function BasicCrudScreenType ( props ) {

    const { t } = useTranslation();

    const {

        id,

        embededInOtherScreenType,
        
        noHeader,
        noCreate,
        noEdit,
        noDelete,
        noExcel,
        noSearch,
        noFilter,
        noPagination,

        disableCreate,
        disableEdit,
        disableDelete,
        disableExcel,
        disableApproval,

        disableGrid,

        approvalCtx,

        defaultOutputSize,
        
        headerTitle,
        headerTitleStyle,

        table,
        view,
        
        makeDeleteItemName,

        fixedOrder,

        buttonsInFrontOfSearch,

        $queries,

        onInitialized,
        onApiInitialized,
        onOrderByInitialized,
        onInstanceInitialized,
        
        onLoadData,
        onModifyTableSchema,
        onModifyViewSchema,

        onModifyViewUrl,

        onAppendHeaderAtFirst,
        onAppendContentAtFirst,
        onAppendFooterAtFirst,

        onAppendHeaderAtLast,
        onAppendContentAtLast,
        onAppendFooterAtLast,

        onAppendButtonAtFirst,
        onAppendButtonAtLast,
        onAppendButtonInFrontOfSearch,
        
        exportFormatItem,

        createButtonName,
    
    } = props;

    const [ , setInstance ] = useState( null );
    const [ tableSchema, setTableSchema ] = useState();
    const [ viewSchema, setViewSchema ] = useState();
    const [ viewApi, setViewApi ] = useState();
    const [ , setForm ] = useState ();
    const [ filter, setFilter ] = useState();
    const [ filterApplyButton, setFilterApplyButton ] = useState();
    const [ filterValue, setFilterValue ] = useState ();
    const [ showFilter, setShowFilter ] = useState(false);
    const [ , setFilterDialog ] = useState();
    const [ search, setSearch ] = useState();
    const [ pagination, setPagination ] = useState();
    const [ count, setCount ] = useState(0);
    const [ size, setSize ] = useState(defaultOutputSize || uiConf.defaultOutputSize);
    const [ grid, setGrid ] = useState();
    const [ useFilterDialog, setUseFilterDialog ] = useState(false);

    const setNotification = useSetRecoilState(notificationState);

    useEffect ( () => {

        let mounted = true;

        let instance = {

            refresh: () => {

                setViewApi ( ( api ) => {
                        
                    api.refresh ();
                    return api;

                } );

            },
            notifySuccess: notifySuccess,
            notifyError: notifyError,
            notifyWarning: notifyWarning,

        };

        setInstance ( instance );

        if ( onInstanceInitialized ) {

            onInstanceInitialized ( instance );

        }

        ( async () => {

            let useFilterDialog = await getOption ( "default", "useFilterDialog" );

            if ( mounted ) {

                if ( useFilterDialog && ( useFilterDialog.toLowerCase () === "true" ) ) {

                    setUseFilterDialog ( true );
    
                } else {
    
                    setUseFilterDialog ( false );
    
                }
    
            }

        } ) ();

        return ( () => {
            mounted = false;
        } );

    }, [] );

    useEffect ( () => {

        let mounted = true;

        ( async () => {

            if ( table ) {

                let schema = await getSchema ( table );

                if ( mounted ) {
                
                    if ( onModifyTableSchema ) {
    
                        onModifyTableSchema ( schema );
        
                    }
        
                    setTableSchema ( schema );
    
                }
    
            }

        } ) ();

        return ( () => {
            mounted = false;
        } );

    }, [table] );

    useEffect ( () => {

        let mounted = true;

        ( async () => {

            if ( view ) {

                let schema = await getSchema ( view );

                if ( mounted ) {
                
                    if ( onModifyViewSchema ) {
        
                        onModifyViewSchema ( schema );
        
                    }
                    
                    setViewSchema ( schema );
                    
                }
    
            } else {

                setViewSchema ( undefined );

            }

        } ) ();

        return ( () => {
            mounted = false;
        } );

    }, [view] );

    const notifySuccess = (msg) => {

        if ( embededInOtherScreenType ) {

            if ( props.onNotifySuccess ) {

                props.onNotifySuccess ( msg );

            }

            return;

        }

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
        
    };

    const notifyError = (msg) => {

        if ( embededInOtherScreenType ) {

            if ( props.onNotifyError ) {

                props.onNotifyError ( msg );
                
            }

            return;

        }

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
        
    };

    const notifyWarning = (msg) => {

        if ( embededInOtherScreenType ) {

            if ( props.onNotifyWarning ) {

                props.onNotifyWarning ( msg );
                
            }

            return;

        }

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
        
    };

    const onSuccess = ( msg ) => {

        notifySuccess ( msg );

    };

    const onFailureWithReason = ( reason ) => {

        notifyError ( reason.response ? reason.response.data : reason );

    };

    const onFailureWithMsg = ( reason ) => {

        notifyError ( reason.response ? reason.response.data : reason );

    };

    const onPartialFailure = ( msg ) => {

        notifyWarning ( msg );

    };

    const onViewApiInitialized = ( viewApi ) => {

        setViewApi ( viewApi );

        if ( onApiInitialized ) {

            onApiInitialized ( viewApi );

        }

    };

    const onFormInitialized = ( form ) => {

        setForm ( form );

    }

    const onFilterInitialized = ( filter ) => {

        setFilter ( filter );

    };

    const onFilterApplyButtonInitialized = ( filterApplyButton ) => {

        setFilterApplyButton ( filterApplyButton );

    };

    const onApplyFilter = ( filterValue ) => {

        if ( filterValue ) {

            setFilterValue ( [...filterValue] );

        } else {

            setFilterValue ( () => {

                let newFilterValue = [];

                for ( const column of viewSchema.columns ) {
        
                    if ( column.filter ) {
    
                        newFilterValue.push ( {
    
                            binding: column.name,
                            type: "condition",
                            and: true,
                            condition1: { operator: "", value: "" },
                            condition2: { operator: "", value: "" }
    
                        } );
    
                    }
                }

                return newFilterValue;

            });
        }
        
    }

    const onClearFilter = () => {


        setForm ( ( form ) => {

            form.clear ();
            return form;

        } );

    }

    const toggleOpenFilter = () => {

        setUseFilterDialog ( ( useFilterDialog ) => {

            if ( useFilterDialog ) {

                setFilterDialog ( ( filterDialog ) => {

                    filterDialog.show ();

                    return filterDialog;

                } );


            } else {

                setShowFilter ( ( showFilter ) => ( !showFilter ) );

            }

            return useFilterDialog;

        } );

    };

    const onSearchInitialized = ( search ) => {

        setSearch ( search );

    }

    const onSearchChange = () => {

        setPagination ( ( pagination ) => {

            if ( pagination ) {

                pagination.set ( 1 );

            }

            return pagination;

        } );
        
    }

    const onPaginationInitialized = ( pagination ) => {

        setPagination ( pagination );

    };

    const onCountChange = ( count ) => {

        setCount ( parseInt(count) );

    };

    const onSizeChange = ( size ) => {

        setSize ( parseInt(size) );

    }

    const closeFilter = () => {

        setShowFilter ( false );

    };

    const onGridInitialized = ( grid ) => {

        setGrid ( grid );
        
        if ( onInitialized ) {

            onInitialized ( grid );

        }

    };

    const onFilterDialogInitialized = ( dialog ) => {

        setFilterDialog ( dialog );

    };

    return (

        <div>

            <BasicCrudScreenTypeLayout>

                {
                    
                    noHeader
                    ?
                    <></>
                    :
                    <BasicCrudScreenHeaderLayout className="basicCrudScreenHeaderLayout">


                        <BasicCrudActionsLayout className="basicCrudScreenActionsLayout">

        
                            {/* Action Button ids and Dialog ids are assigned inside Action Button Component */}

                            {
                                onAppendHeaderAtFirst
                                ?
                                onAppendHeaderAtFirst ()
                                :
                                <></>
                            }

                            {
                                headerTitle
                                ?
                                <span
                                    color="inherit"
                                    align="center"
                                    style={
                                        headerTitleStyle
                                        ||
                                        {
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                            marginLeft: "8px",
                                            marginTop: "20px"
                                        }
                                    }>
                                    { headerTitle }
                                </span>
                                :
                                <></>
                            }

                            <Hidden xsDown>

                            {
                                onAppendButtonAtFirst
                                ?
                                onAppendButtonAtFirst ()
                                :
                                <></>
                            }

                            {
                                buttonsInFrontOfSearch
                                ?
                                <ToolbarFlexSpacer xs />
                                :
                                <></>
                            }

                            {
                                noCreate
                                ?
                                <></>
                                :
                                <BasicCrudScreenActionItemLayout>

                                    <AccessControl accessTarget={tableSchema && tableSchema.name} accessMethod="POST">
                                        <CreateRecordButton
                                            id={id}
                                            schema={tableSchema}
                                            refresh={viewApi}
                                            diabled={disableCreate}
                                            onSuccess={onSuccess}
                                            createButtonName ={createButtonName}

                                        />
                                    </AccessControl>

                                </BasicCrudScreenActionItemLayout>
                            }

                            {
                                noEdit
                                ?
                                <></>
                                :
                                <BasicCrudScreenActionItemLayout>

                                    <AccessControl accessTarget={tableSchema && tableSchema.name} accessMethod={tableSchema && (tableSchema.updateWithPatch?"PATCH":"PUT")}>
                                        <UpdateRecordButton
                                                id={id}
                                                schema={tableSchema}
                                                grid={grid}
                                                refresh={viewApi}
                                                disabled={parseInt(count)===0 || disableEdit}
                                                onSuccess={onSuccess}
                                            />
                                    </AccessControl>

                                </BasicCrudScreenActionItemLayout>
                            }

                            {
                                noDelete
                                ?
                                <></>
                                :
                                <BasicCrudScreenActionItemLayout>

                                    <AccessControl accessTarget={tableSchema && tableSchema.name} accessMethod="DELETE">
                                        <DeleteRecordButton
                                            id={id}
                                            schema={tableSchema}
                                            grid={grid}
                                            refresh={viewApi}
                                            color="secondary"
                                            disabled={parseInt(count)===0 || disableDelete}
                                            makeItemName={makeDeleteItemName}
                                            onSuccess={onSuccess}
                                            onFailure={onFailureWithMsg}
                                            onPartialFailure={onPartialFailure}
                                        />
                                    </AccessControl>

                                </BasicCrudScreenActionItemLayout>
                            }

                            {
                                approvalCtx
                                ?
                                <BasicCrudScreenActionItemLayout>

                                    <AccessControl accessTarget={tableSchema && tableSchema.name} accessMethod="APPROVAL">
                                        <ApprovalButton
                                            id={id}
                                            grid={grid}
                                            refresh={viewApi}
                                            approvalCtx={approvalCtx}
                                            disabled={parseInt(count)===0 || disableApproval}
                                            onSuccess={onSuccess}
                                            onFailure={onFailureWithMsg}
                                        />
                                    </AccessControl>

                                </BasicCrudScreenActionItemLayout>
                                :
                                <></>
                            }

                            {
                                noExcel
                                ?
                                <></>
                                :
                                <BasicCrudScreenActionItemLayout>

                                    <AccessControl accessTarget={viewSchema && viewSchema.name} accessMethod="SAVETOEXCEL">
                                        <SaveToExcelButton
                                            id={id}
                                            grid={grid}
                                            view={view}
                                            color="primary"
                                            exportFormatItem={exportFormatItem}
                                            disabled={parseInt(count)===0 || disableExcel}
                                        />
                                    </AccessControl>

                                </BasicCrudScreenActionItemLayout>
                            }

                            {
                                onAppendButtonAtLast
                                ?
                                onAppendButtonAtLast ()
                                :
                                <></>
                            }

                            </Hidden>

                            <Hidden smDown>

                            {

                                buttonsInFrontOfSearch
                                ?
                                <></>
                                :
                                <ToolbarFlexSpacer xs />

                            }

                            {
                                onAppendButtonInFrontOfSearch
                                ?
                                onAppendButtonInFrontOfSearch ()
                                :
                                <></>
                            }

                            {
                                noSearch
                                ?
                                <></>
                                :
                                <BasicCrudScreenActionItemLayout>

                                    <SearchTextField
                                        id={id+"-search-text"}
                                        className="basicCrudScreenSearchInput"
                                        search={search}
                                    />

                                </BasicCrudScreenActionItemLayout>
                            }

                            {
                                noFilter
                                ?
                                <></>
                                :
                                <BasicCrudScreenActionItemLayout>

                                    <OpenFilterButton
                                        id={id+"-open-filter-button"}
                                        className="basicCrudScreenOpenFilterButton"
                                        color="primary"
                                        onClick={toggleOpenFilter}
                                        style={{marginTop: "4px"}}
                                    />
                                    
                                </BasicCrudScreenActionItemLayout>
                            }

                            </Hidden>

                            {

                                buttonsInFrontOfSearch
                                ?
                                <></>
                                :
                                <Hidden mdUp>
                                
                                    <ToolbarFlexSpacer xs />

                                    {
                                        onAppendButtonInFrontOfSearch
                                        ?
                                        onAppendButtonInFrontOfSearch ()
                                        :
                                        <></>
                                    }

                                </Hidden>

                            }

                            {
                                onAppendHeaderAtLast
                                ?
                                onAppendHeaderAtLast ()
                                :
                                <></>
                            }

                        </BasicCrudActionsLayout>

                        {
                            noFilter
                            ?
                            <></>
                            :
                            (
                                useFilterDialog
                                ?
                                <FilterDialog

                                    id={id+"-filter-dialog"}
                                    title={t("dialog.title.Filter")}
                                    schema={viewSchema}
                                    filter={filter}
                                    filterValue={filterValue?cloneDeep(filterValue):filterValue}
                                    onInitialized={onFilterDialogInitialized}
                                    onFormInitialized={onFormInitialized}
                                    onApply={onApplyFilter}
                                    onClear={onClearFilter}
                                    onCancel={closeFilter}

                                />
                                :
                                <FilterConditionPanelLayout
                                    className="basicCrudScreenFilterPanel"
                                    show={showFilter}
                                >

                                    <AutoFilterForm
                                        id={id+"-filter-form"}
                                        className="autoFilterForm"
                                        schema={viewSchema}
                                        filterValue={filterValue?cloneDeep(filterValue):filterValue} // object deep copy - 내부에서 객체 멤버가 수정되어 버그 발생
                                        filterApplyButton={filterApplyButton}
                                        onInitialized={onFormInitialized}
                                    />
                                    <FilterApplyButton
                                        id={id+"-filter-apply-button"}
                                        className="filterApplyButton"
                                        schema={viewSchema}
                                        filter={filter}
                                        onApply={onApplyFilter}
                                        onInitialized={onFilterApplyButtonInitialized}
                                    />
                                    <FilterClearButton
                                        id={id+"-filter-clear-button"}
                                        className="filterClearButton"
                                        onClear={onClearFilter}
                                    />
                                    <FilterCancelButton
                                        id={id+"-filter-cancel-button"}
                                        className="filterCancelButton"
                                        onCancel={closeFilter}
                                    />                    

                                </FilterConditionPanelLayout>

                            )
                        }
                        
                    </BasicCrudScreenHeaderLayout>

                }

                {
                    noPagination
                    ?
                    <BasicCrudScreenContentWithoutFooterLayout className="basicCrudScreenContentLayout">

                        {
                            onAppendContentAtFirst
                            ?
                            onAppendContentAtFirst ()
                            :
                            <></>
                        }

                        <Filter onInitialized={onFilterInitialized} >

                            <Search onChange={onSearchChange} onInitialized={onSearchInitialized}>

                                <OrderBy schema={viewSchema} grid={grid} fixedOrder={fixedOrder} onInitialized={onOrderByInitialized} >

                                    <GetListApi table={view} onModifyUrl={onModifyViewUrl} $queries={$queries} onCountChange={onCountChange} onLoadData={onLoadData} onFailure={onFailureWithReason} onInitialized={onViewApiInitialized}  >

                                        <AutoDataGrid id={id+"-data-grid"} schema={viewSchema} isDisabled={disableGrid} onInitialized={onGridInitialized}  />

                                    </GetListApi>

                                </OrderBy>

                            </Search>

                        </Filter>

                        {
                            onAppendContentAtLast
                            ?
                            onAppendContentAtLast ()
                            :
                            <></>
                        }

                    </BasicCrudScreenContentWithoutFooterLayout>
                    :
                    <BasicCrudScreenContentLayout className="basicCrudScreenContentLayout">

                        {
                            onAppendContentAtFirst
                            ?
                            onAppendContentAtFirst ()
                            :
                            <></>
                        }

                        <Filter onInitialized={onFilterInitialized} >

                            <Search onChange={onSearchChange} onInitialized={onSearchInitialized}>

                                <OrderBy schema={viewSchema} grid={grid} fixedOrder={fixedOrder} onInitialized={onOrderByInitialized} >

                                    <Pagination size={size} onInitialized={onPaginationInitialized}>

                                        <GetListApi table={view} onModifyUrl={onModifyViewUrl} $queries={$queries} onCountChange={onCountChange} onLoadData={onLoadData} onFailure={onFailureWithReason} onInitialized={onViewApiInitialized}  >

                                            <AutoDataGrid id={id+"-data-grid"} schema={viewSchema} isDisabled={disableGrid} onInitialized={onGridInitialized}  />

                                        </GetListApi>

                                    </Pagination>

                                </OrderBy>

                            </Search>

                        </Filter>

                        {
                            onAppendContentAtLast
                            ?
                            onAppendContentAtLast ()
                            :
                            <></>
                        }

                    </BasicCrudScreenContentLayout>                    
                }

                {
                    noPagination
                    ?
                    <></>
                    :
                    <BasicCrudScreenFooterLayout className="basicCrudScreenFooterLayout" embededInOtherScreenType={embededInOtherScreenType}>
                        
                        {
                            onAppendFooterAtFirst
                            ?
                            onAppendFooterAtFirst ()
                            :
                            <></>
                        }

                        <ToolbarFlexSpacer xs />

                            <PaginationControl
                                id={id+"-pagination-control"}
                                className="pagintationConterol"
                                color="primary"
                                style={{leftMargin:0, rightMargin:0, marginTop: "12px"}}
                                pagination={pagination}
                                showFirstButton={true}
                                showLastButton={true}
                                size={size}
                                count={count}
                            />

                        <ToolbarFlexSpacer xs />

                        {
                            <BasicCrudScreenActionItemLayout>

                                <OutputSizeSelect
                                    id={id+"-output-size-select"}
                                    className="outputSizeSelect"
                                    onChange={onSizeChange}
                                />

                            </BasicCrudScreenActionItemLayout>
                        }
                        
                        {
                            onAppendFooterAtLast
                            ?
                            onAppendFooterAtLast ()
                            :
                            <></>
                        }

                    </BasicCrudScreenFooterLayout>

                }


            </BasicCrudScreenTypeLayout>
            
        </div>

    );

}

export default BasicCrudScreenType;
